export const ORG_NAME_LABEL = $localize`Organization Name`;
export const NAME_PLACEHOLDER = $localize`Enter organization name`;
export const ORG_ADDRESS_LABEL = $localize`Organization Address`;
export const ORG_ADDRESS_PLACEHOLDER = $localize`Enter address`;
export const ORG_CONTACT_LABEL = $localize`Organization Phone Number`;
export const CONTACT_PLACEHOLDER = $localize`Enter phone number`;
export const ADMIN_NAME_LABEL = $localize`Admin Name`;
export const ADMIN_NAME_PLACEHOLDER = $localize`Enter admin name`;
export const EMAIL_INPUT_TYPE = 'email';
export const ADMIN_EMAIL_LABEL = $localize`Admin Email Address`;
export const ADMIN_EMAIL_PLACEHOLDER = $localize`Enter email address`;
export const POPUP_OK = $localize`OK`;
export const BUTTON_SAVE = $localize`Save`;
export const BUTTON_CANCEL = $localize`Cancel`;
export const ARIAL_LABEL = 'sample arial label';
/**
 * fixme: delete the following and work them into app-buttons
 * app-buttons only provides certain styles, but it doesn't type its inputs,
 * so it's hard to know what's what. About a dozen files import these constants,
 * but the button component should instead just declare what it accepts, and not
 * accept anything else...
 */
export const BTN_MAT = 'mat-button';
export const BTN_STYLE_TEXT = 'btn-text';
export const BTN_MAT_FLAT = 'mat-flat-button';
export const BTN_STYLE_FILLED_SMALL = 'btn-filled-small';
export const BTN_STYLE_FILLED_SMALL_DISABLED = 'btn-filled-small-disabled';
// ^^^^
